import httpClient from '@/http-client'

export const get = (options = {}) => {
    return httpClient
        .get('/api/candidate-certificates', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const formModel = (options = {}) => {
    return httpClient
        .get('/api/candidate-certificates/form-view-models', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}


export default { get, formModel }

